<div id="confirm">
  <h1>
    {{ 'rspConfirmHeading' | translate }}
    @if (insuredPersonFullName) {
      <br />
      {{ 'rspInsuredPersonText' | translate: { insuredPersonName: insuredPersonFullName } }}
    }
  </h1>
  <div id="confirm-information" class="confirm-information" [innerHTML]="'rspConfirmInformation' | translate"></div>

  @let hasDeclaredAccuracyCheckboxInvalid =
    confirmForm.controls?.['hasDeclaredAccuracy'].invalid && confirmForm.controls?.['hasDeclaredAccuracy'].touched;
  @let hasConfirmedCheckboxInvalid = confirmForm.controls?.['hasConfirmed'].invalid && confirmForm.controls?.['hasConfirmed'].touched;
  @let shouldShowInvalidFeedback = hasDeclaredAccuracyCheckboxInvalid || hasConfirmedCheckboxInvalid;

  <form class="needs-validation" [formGroup]="confirmForm" (ngSubmit)="confirm()">
    <div>
      <label for="has-declared-accuracy-checkbox" class="form-check-label">
        <input
          id="has-declared-accuracy-checkbox"
          class="form-check-input"
          type="checkbox"
          formControlName="hasDeclaredAccuracy"
          aria-required="true"
          [class.is-invalid]="hasDeclaredAccuracyCheckboxInvalid"
          [attr.aria-invalid]="confirmForm.controls?.['hasDeclaredAccuracy'].invalid"
        />
        {{ 'rspConfirmCheckboxAccurate' | translate }}
      </label>
    </div>
    <div>
      <label for="has-confirmed-checkbox" class="form-check-label">
        <input
          id="has-confirmed-checkbox"
          class="form-check-input"
          type="checkbox"
          formControlName="hasConfirmed"
          aria-required="true"
          [class.is-invalid]="hasConfirmedCheckboxInvalid"
          [attr.aria-invalid]="confirmForm.controls?.['hasConfirmed'].invalid"
        />
        {{ 'rspConfirmCheckboxConfirm' | translate }}
      </label>
    </div>
    <div aria-live="polite" class="mt-0">
      @if (shouldShowInvalidFeedback) {
        <p class="rsp-invalid-form-feedback invalid-feedback d-block m-0" [innerHTML]="'rspFormInvalid' | translate"></p>
      } @else {
        <p class="rsp-invalid-form-feedback invisible m-0"></p>
      }
    </div>
    <div class="d-flex justify-content-between">
      <button id="back-btn" class="btn btn-secondary" (click)="goBack()" type="button">
        {{ 'rspConfirmButtonBack' | translate }}
      </button>
      <button
        id="confirm-btn"
        class="btn btn-primary"
        type="submit"
        [attr.aria-disabled]="confirmForm.invalid"
        [disabled]="confirmForm.invalid && isDisableable"
      >
        {{ 'rspConfirmButtonContinue' | translate }}
      </button>
    </div>
  </form>
</div>
